// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"6ca2899b","486":"4b351799","787":"8912971e"}[chunkId] + ".chunk.js";
};